// Fragment "client transactions" — merged into ./index.js.
// Convention: flat dotted keys, values in the 3 languages, never empty.
//
// Backs two things that must stay disambiguated from each other and from the SaaS
// ledger (base.js `tx.*` — what a practice PAYS Solunary):
//   - super_admin/ClientTransactionsList.jsx: the cross-tenant ledger of what every
//     tenant's OWN clients paid THEM (client-sales), GET /super-admin/client-transactions.
//   - super_admin/tenant360/SectionsPanel.jsx: the `client_transactions` section entry, and the
//     note line above each of the two money sections (whose money it is; the figures carry
//     their own currency).
export default {
  fr: {
    "nav.clientTransactions": "Transactions clients",
    "t360.sec.clientTransactions": "Transactions clients",
    "t360.note.transactions": "Ce que ce cabinet paie à Solunary.",
    "t360.note.clientTransactions": "Ce que ce cabinet encaisse auprès de ses clients.",

    "ctx.title": "Transactions clients",
    "ctx.subtitle": "Ventes encaissées par les praticiens auprès de leurs propres clients.",
    "ctx.countAll": "{n} transactions dans tous les cabinets",
    "ctx.countAllOne": "{n} transaction dans tous les cabinets",
    "ctx.countFiltered": "{n} transactions correspondant à : {filters}",
    "ctx.countFilteredOne": "{n} transaction correspondant à : {filters}",
    "ctx.allKinds": "— Tous les types —",
    "ctx.all": "Tous",
    "ctx.paymentStatusLabel": "Paiement :",
    "ctx.refundStatusLabel": "Remboursement :",
    "ctx.paymentStatus.paid": "Payé",
    "ctx.paymentStatus.unpaid": "Impayé",
    "ctx.refundStatus.none": "Aucun",
    "ctx.refundStatus.partial": "Partiel",
    "ctx.refundStatus.refunded": "Remboursé",
    "ctx.refundStatus.unverified": "Non confirmé",
    "ctx.kind.booking": "Rendez-vous",
    "ctx.kind.course": "Cours",
    "ctx.kind.pathway": "Parcours",
    "ctx.kind.pack": "Forfait de séances",
    "ctx.kind.product": "Produit",
    "ctx.kind.program": "Programme",
    "ctx.kind.invoice": "Facture",
    "ctx.kind.giftcard": "Carte-cadeau",
    "ctx.kind.legacyTelehealth": "Téléconsultation (prépayée, retirée)",
    "ctx.kind.other": "Autre",
    "ctx.colDate": "Date",
    "ctx.colTenant": "Cabinet",
    "ctx.colKind": "Type",
    "ctx.colCollected": "Encaissé",
    "ctx.colTax": "Taxes",
    "ctx.colCommission": "Commission",
    "ctx.colOwed": "Dû au praticien",
    "ctx.colRefunded": "Remboursé",
    "ctx.colStatus": "Statut",
    "ctx.colCheckoutRef": "Référence de paiement",
    "ctx.status.refunded": "Remboursé",
    "ctx.status.partial": "Partiellement remboursé",
    "ctx.status.disputed": "Contesté",
    "ctx.status.refundOwed": "Remboursement dû",
    "ctx.status.refundUnverified": "Remboursement non confirmé",
    "ctx.status.refundUnverifiedHint": "Stripe n'a pas confirmé ce remboursement : il a peut-être été versé au client. À rapprocher dans Stripe avant tout autre remboursement.",
    "ctx.status.paid": "Payé",
    "ctx.status.initiated": "Paiement démarré",
    "ctx.status.open": "Paiement ouvert",
    "ctx.status.expired": "Paiement expiré",
    "ctx.status.failed": "Échoué",
    "ctx.rail.platform": "Plateforme",
    "ctx.rail.connect": "Connect",
    "ctx.railLine": "Rail : {rail}",
    "ctx.empty": "Aucune transaction pour ces filtres.",
    "ctx.totalLabel": "Total ({cur})",
    "ctx.totalCount": "{n} transactions",
    "ctx.totalCountOne": "{n} transaction",
    "ctx.totalExcluded": "hors {n} lignes sans chiffre",
    "ctx.totalExcludedOne": "hors {n} ligne sans chiffre",
    "ctx.moneyHelpTitle": "Comment ces montants sont calculés",
    "ctx.moneyHelp.collected": "Encaissé : ce que le client a payé, taxes comprises, moins les remboursements et les rétrofacturations (l'argent qu'une banque a repris par un litige, tant que le litige n'est pas gagné).",
    "ctx.moneyHelp.giftcard": "Cartes-cadeaux : une carte-cadeau est encaissée une seule fois, à sa vente. La part d'un achat réglée par carte-cadeau figure à côté de l'encaissé, pas dedans.",
    "ctx.moneyHelp.refunded": "Remboursé : seulement l'argent rendu au client. La valeur rendue à une carte-cadeau figure sur sa propre ligne.",
    "ctx.moneyHelp.owed": "Dû au praticien : sa part de la vente, taxes comprises (il les reverse), qu'elle ait déjà été versée ou non. C'est Encaissé + carte-cadeau − Commission, sauf pour la vente d'une carte-cadeau, dont la valeur est réservée à son utilisation et n'est encore due à aucun praticien.",
    "ctx.moneyHelp.chargeback": "Rétrofacturations : une rétrofacturation ne réduit le dû et la commission qu'une fois la perte récupérée auprès du praticien.",
    "ctx.moneyHelp.source": "Les ventes inscrites au grand livre de paiement affichent ses montants, dans sa devise de règlement ; les ventes antérieures et les commandes payées entièrement par carte-cadeau affichent leur fiche de paiement.",
    "ctx.afterRefund": "Après remboursement",
    "ctx.charged": "Débité {amount}",
    "ctx.checkoutAmount": "Montant demandé {amount}",
    "ctx.notCollected": "Non encaissé",
    "ctx.commissionKept": "conservée après remboursement",
    "ctx.owedAfterRefund": "dû après remboursement",
    "ctx.taxNotRecorded.refund": "La taxe n'est pas enregistrée après un remboursement",
    "ctx.taxNotRecorded.chargeback": "La taxe n'est pas enregistrée après une rétrofacturation",
    "ctx.taxNotRecorded.refundAndChargeback": "La taxe n'est pas enregistrée après un remboursement et une rétrofacturation",
    "ctx.giftcardHeld": "Réservé au solde de la carte-cadeau",
    "ctx.preLedgerRecord": "Vente antérieure au grand livre : fiche de paiement",
    "ctx.preLedgerAdjusted": "Vente antérieure au grand livre : non enregistré après remboursement ou litige",
    "ctx.ledgerUnavailable": "Aucune écriture au grand livre pour cette vente",
    "ctx.ledgerMixedCurrency": "Écritures au grand livre en plusieurs devises : elles ne peuvent pas être additionnées",
    "ctx.ledgerDisagrees.capture": "Le grand livre enregistre un paiement que cette vente n'indique pas",
    "ctx.ledgerDisagrees.refund": "Le grand livre et cette vente divergent sur le remboursement",
    "ctx.totalsLedgerCaptured.hidden": "{n} ventes sont enregistrées comme impayées alors que le grand livre détient leur paiement : elles ne figurent ni dans cette vue ni dans ces totaux. Choisissez « {unpaid} » pour les voir.",
    "ctx.totalsLedgerCaptured.hiddenOne": "{n} vente est enregistrée comme impayée alors que le grand livre détient son paiement : elle ne figure ni dans cette vue ni dans ces totaux. Choisissez « {unpaid} » pour la voir.",
    "ctx.totalsLedgerCaptured.listed": "{n} paiements non aboutis sont des paiements que le grand livre détient : la fiche des ventes et le grand livre divergent, et ils ne figurent pas dans ces totaux.",
    "ctx.totalsLedgerCaptured.listedOne": "{n} paiement non abouti est un paiement que le grand livre détient : la fiche de la vente et le grand livre divergent, et il ne figure pas dans ces totaux.",
    "ctx.totalsLabel.paid": "Montants encaissés, après remboursements et rétrofacturations : toutes les transactions payées correspondant aux filtres (toutes les pages)",
    "ctx.totalsLabel.all": "Montants encaissés, après remboursements et rétrofacturations, pour toutes les transactions correspondant aux filtres (toutes les pages). Les paiements non aboutis sont comptés à part et n'ajoutent rien.",
    "ctx.totalsLabel.unpaid": "Paiements non aboutis : rien n'a été encaissé, donc ni commission ni versement.",
    "ctx.totalsLoading": "Calcul des totaux…",
    "ctx.totalsTooLarge": "Trop de transactions correspondent à ces filtres pour les totaliser à temps. Affinez les filtres (un cabinet, un type ou un statut) pour voir les totaux.",
    "ctx.totalsFailed": "Les totaux n'ont pas pu être chargés.",
    "ctx.totalNotCollected": "{n} paiements non aboutis ({amount}), hors de ces totaux",
    "ctx.totalNotCollectedOne": "{n} paiement non abouti ({amount}), hors de ces totaux",
    "ctx.totalOtherCurrency": "dont {n} ventes facturées dans une autre devise",
    "ctx.totalOtherCurrencyOne": "dont {n} vente facturée dans une autre devise",
    "ctx.giftcardApplied": "+ {amount} par carte-cadeau",
    "ctx.giftcardCoveredRecord": "Payé entièrement par carte-cadeau : fiche de paiement",
    "ctx.giftcardCoveredAdjusted": "Payé par carte-cadeau : non enregistré après remboursement",
    "ctx.giftcardReturned": "{amount} rendus à la carte-cadeau",
    "ctx.totalGiftcardReturned": "{amount} rendus aux cartes-cadeaux",
    "ctx.chargeback": "Rétrofacturation",
    "ctx.afterChargeback": "Après une rétrofacturation",
    "ctx.owedAfterChargeback": "réduit par une rétrofacturation seulement une fois récupérée auprès du praticien",
    "ctx.totalChargeback": "Rétrofacturations : −{amount}",
    "ctx.captureUnbooked": "Encaissé, pas encore inscrit au grand livre",
    "ctx.totalNotCollectedNoAmount": "{n} paiements non aboutis, hors de ces totaux",
    "ctx.totalNotCollectedNoAmountOne": "{n} paiement non abouti, hors de ces totaux",
    "ctx.refHelp": "La référence de paiement identifie la vente chez Stripe. Les remboursements clients sont émis par le cabinet depuis sa propre administration, à partir de cette référence.",
  },
  en: {
    "nav.clientTransactions": "Client transactions",
    "t360.sec.clientTransactions": "Client transactions",
    "t360.note.transactions": "What this practice pays Solunary.",
    "t360.note.clientTransactions": "What this practice collects from its clients.",

    "ctx.title": "Client transactions",
    "ctx.subtitle": "Sales practitioners collected from their own clients.",
    "ctx.countAll": "{n} transactions across all practices",
    "ctx.countAllOne": "{n} transaction across all practices",
    "ctx.countFiltered": "{n} transactions matching: {filters}",
    "ctx.countFilteredOne": "{n} transaction matching: {filters}",
    "ctx.allKinds": "— All kinds —",
    "ctx.all": "All",
    "ctx.paymentStatusLabel": "Payment:",
    "ctx.refundStatusLabel": "Refund:",
    "ctx.paymentStatus.paid": "Paid",
    "ctx.paymentStatus.unpaid": "Unpaid",
    "ctx.refundStatus.none": "None",
    "ctx.refundStatus.partial": "Partial",
    "ctx.refundStatus.refunded": "Refunded",
    "ctx.refundStatus.unverified": "Unconfirmed",
    "ctx.kind.booking": "Appointment",
    "ctx.kind.course": "Course",
    "ctx.kind.pathway": "Pathway",
    "ctx.kind.pack": "Session pack",
    "ctx.kind.product": "Product",
    "ctx.kind.program": "Program",
    "ctx.kind.invoice": "Invoice",
    "ctx.kind.giftcard": "Gift card",
    "ctx.kind.legacyTelehealth": "Telehealth (prepaid, retired)",
    "ctx.kind.other": "Other",
    "ctx.colDate": "Date",
    "ctx.colTenant": "Practice",
    "ctx.colKind": "Kind",
    "ctx.colCollected": "Collected",
    "ctx.colTax": "Tax",
    "ctx.colCommission": "Commission",
    "ctx.colOwed": "Owed to practitioner",
    "ctx.colRefunded": "Refunded",
    "ctx.colStatus": "Status",
    "ctx.colCheckoutRef": "Checkout reference",
    "ctx.status.refunded": "Refunded",
    "ctx.status.partial": "Partially refunded",
    "ctx.status.disputed": "Disputed",
    "ctx.status.refundOwed": "Refund owed",
    "ctx.status.refundUnverified": "Refund unconfirmed",
    "ctx.status.refundUnverifiedHint": "Stripe did not confirm this refund: it may have reached the client. Reconcile it in Stripe before any further refund.",
    "ctx.status.paid": "Paid",
    "ctx.status.initiated": "Checkout started",
    "ctx.status.open": "Checkout open",
    "ctx.status.expired": "Checkout expired",
    "ctx.status.failed": "Failed",
    "ctx.rail.platform": "Platform",
    "ctx.rail.connect": "Connect",
    "ctx.railLine": "Rail: {rail}",
    "ctx.empty": "No transactions for these filters.",
    "ctx.totalLabel": "Total ({cur})",
    "ctx.totalCount": "{n} transactions",
    "ctx.totalCountOne": "{n} transaction",
    "ctx.totalExcluded": "excl. {n} rows with no figure",
    "ctx.totalExcludedOne": "excl. {n} row with no figure",
    "ctx.moneyHelpTitle": "How these figures are computed",
    "ctx.moneyHelp.collected": "Collected: what the client paid, tax included, minus refunds and chargebacks (money a bank took back through a dispute, until the dispute is won).",
    "ctx.moneyHelp.giftcard": "Gift cards: a gift card is collected once, when it is sold. The part of a purchase paid by gift card is shown beside Collected, not in it.",
    "ctx.moneyHelp.refunded": "Refunded: only the money returned to the client. Value given back to a gift card is shown on its own line.",
    "ctx.moneyHelp.owed": "Owed to practitioner: their share of the sale, tax included (they remit it), whether or not already paid out. It is Collected + gift card − Commission, except on a gift-card sale, whose value is held for redemption and owed to no practitioner yet.",
    "ctx.moneyHelp.chargeback": "Chargebacks: a chargeback lowers Owed and Commission only once the loss is recovered from the practitioner.",
    "ctx.moneyHelp.source": "Sales in the payment ledger show its figures, in the currency it settles in; pre-ledger sales and orders paid in full by gift card show their checkout record.",
    "ctx.afterRefund": "After refund",
    "ctx.charged": "Charged {amount}",
    "ctx.checkoutAmount": "Checkout amount {amount}",
    "ctx.notCollected": "Not collected",
    "ctx.commissionKept": "kept after refund",
    "ctx.owedAfterRefund": "owed after refund",
    "ctx.taxNotRecorded.refund": "Tax is not recorded after a refund",
    "ctx.taxNotRecorded.chargeback": "Tax is not recorded after a chargeback",
    "ctx.taxNotRecorded.refundAndChargeback": "Tax is not recorded after a refund and a chargeback",
    "ctx.giftcardHeld": "Held for gift-card redemption",
    "ctx.preLedgerRecord": "Pre-ledger sale: checkout record",
    "ctx.preLedgerAdjusted": "Pre-ledger sale: not recorded after a refund or dispute",
    "ctx.ledgerUnavailable": "No ledger entry found for this sale",
    "ctx.ledgerMixedCurrency": "Ledger entries in more than one currency: they cannot be added up",
    "ctx.ledgerDisagrees.capture": "The ledger records a payment this sale does not show",
    "ctx.ledgerDisagrees.refund": "The ledger and this sale disagree on the refund",
    "ctx.totalsLedgerCaptured.hidden": "{n} sales are recorded as unpaid although the ledger holds their payment: they are not in this view or these totals. Choose “{unpaid}” to see them.",
    "ctx.totalsLedgerCaptured.hiddenOne": "{n} sale is recorded as unpaid although the ledger holds its payment: it is not in this view or these totals. Choose “{unpaid}” to see it.",
    "ctx.totalsLedgerCaptured.listed": "{n} unpaid checkouts are payments the ledger holds: the sale records and the ledger disagree, and they are not in these totals.",
    "ctx.totalsLedgerCaptured.listedOne": "{n} unpaid checkout is a payment the ledger holds: the sale record and the ledger disagree, and it is not in these totals.",
    "ctx.totalsLabel.paid": "Money collected, after refunds and chargebacks: every paid transaction matching the filters (all pages)",
    "ctx.totalsLabel.all": "Money collected, after refunds and chargebacks, for every transaction matching the filters (all pages). Unpaid checkouts are counted separately and add nothing.",
    "ctx.totalsLabel.unpaid": "Unpaid checkouts: no money was collected, so there is no commission or payout.",
    "ctx.totalsLoading": "Computing the totals…",
    "ctx.totalsTooLarge": "Too many transactions match these filters to total them in time. Narrow the filters (a practice, a kind or a status) to see the totals.",
    "ctx.totalsFailed": "The totals could not be loaded.",
    "ctx.totalNotCollected": "{n} unpaid checkouts ({amount}), not in these totals",
    "ctx.totalNotCollectedOne": "{n} unpaid checkout ({amount}), not in these totals",
    "ctx.totalOtherCurrency": "incl. {n} sales charged in another currency",
    "ctx.totalOtherCurrencyOne": "incl. {n} sale charged in another currency",
    "ctx.giftcardApplied": "+ {amount} by gift card",
    "ctx.giftcardCoveredRecord": "Paid in full by gift card: checkout record",
    "ctx.giftcardCoveredAdjusted": "Paid by gift card: not recorded after a refund",
    "ctx.giftcardReturned": "{amount} returned to the gift card",
    "ctx.totalGiftcardReturned": "{amount} returned to gift cards",
    "ctx.chargeback": "Chargeback",
    "ctx.afterChargeback": "After a chargeback",
    "ctx.owedAfterChargeback": "lowered by a chargeback only once recovered from the practitioner",
    "ctx.totalChargeback": "Chargebacks: −{amount}",
    "ctx.captureUnbooked": "Captured, not entered in the ledger yet",
    "ctx.totalNotCollectedNoAmount": "{n} unpaid checkouts, not in these totals",
    "ctx.totalNotCollectedNoAmountOne": "{n} unpaid checkout, not in these totals",
    "ctx.refHelp": "Checkout reference identifies the sale at Stripe. Client refunds are issued by the practice from its own admin, against this reference.",
  },
  es: {
    "nav.clientTransactions": "Transacciones de clientes",
    "t360.sec.clientTransactions": "Transacciones de clientes",
    "t360.note.transactions": "Lo que este centro paga a Solunary.",
    "t360.note.clientTransactions": "Lo que este centro cobra a sus clientes.",

    "ctx.title": "Transacciones de clientes",
    "ctx.subtitle": "Ventas cobradas por los profesionales a sus propios clientes.",
    "ctx.countAll": "{n} transacciones en todas las consultas",
    "ctx.countAllOne": "{n} transacción en todas las consultas",
    "ctx.countFiltered": "{n} transacciones que coinciden con: {filters}",
    "ctx.countFilteredOne": "{n} transacción que coincide con: {filters}",
    "ctx.allKinds": "— Todos los tipos —",
    "ctx.all": "Todos",
    "ctx.paymentStatusLabel": "Pago:",
    "ctx.refundStatusLabel": "Reembolso:",
    "ctx.paymentStatus.paid": "Pagado",
    "ctx.paymentStatus.unpaid": "Sin pagar",
    "ctx.refundStatus.none": "Ninguno",
    "ctx.refundStatus.partial": "Parcial",
    "ctx.refundStatus.refunded": "Reembolsado",
    "ctx.refundStatus.unverified": "Sin confirmar",
    "ctx.kind.booking": "Cita",
    "ctx.kind.course": "Curso",
    "ctx.kind.pathway": "Itinerario",
    "ctx.kind.pack": "Bono de sesiones",
    "ctx.kind.product": "Producto",
    "ctx.kind.program": "Programa",
    "ctx.kind.invoice": "Factura",
    "ctx.kind.giftcard": "Tarjeta regalo",
    "ctx.kind.legacyTelehealth": "Teleconsulta (prepago, retirada)",
    "ctx.kind.other": "Otro",
    "ctx.colDate": "Fecha",
    "ctx.colTenant": "Consulta",
    "ctx.colKind": "Tipo",
    "ctx.colCollected": "Cobrado",
    "ctx.colTax": "Impuestos",
    "ctx.colCommission": "Comisión",
    "ctx.colOwed": "Adeudado al profesional",
    "ctx.colRefunded": "Reembolsado",
    "ctx.colStatus": "Estado",
    "ctx.colCheckoutRef": "Referencia de pago",
    "ctx.status.refunded": "Reembolsado",
    "ctx.status.partial": "Parcialmente reembolsado",
    "ctx.status.disputed": "En disputa",
    "ctx.status.refundOwed": "Reembolso pendiente",
    "ctx.status.refundUnverified": "Reembolso sin confirmar",
    "ctx.status.refundUnverifiedHint": "Stripe no confirmó este reembolso: puede que haya llegado al cliente. Concílielo en Stripe antes de cualquier otro reembolso.",
    "ctx.status.paid": "Pagado",
    "ctx.status.initiated": "Pago iniciado",
    "ctx.status.open": "Pago abierto",
    "ctx.status.expired": "Pago caducado",
    "ctx.status.failed": "Fallido",
    "ctx.rail.platform": "Plataforma",
    "ctx.rail.connect": "Connect",
    "ctx.railLine": "Rail: {rail}",
    "ctx.empty": "No hay transacciones para estos filtros.",
    "ctx.totalLabel": "Total ({cur})",
    "ctx.totalCount": "{n} transacciones",
    "ctx.totalCountOne": "{n} transacción",
    "ctx.totalExcluded": "excl. {n} filas sin cifra",
    "ctx.totalExcludedOne": "excl. {n} fila sin cifra",
    "ctx.moneyHelpTitle": "Cómo se calculan estos importes",
    "ctx.moneyHelp.collected": "Cobrado: lo que pagó el cliente, impuestos incluidos, menos los reembolsos y los contracargos (el dinero que un banco recuperó mediante una disputa, mientras la disputa no se gane).",
    "ctx.moneyHelp.giftcard": "Tarjetas regalo: una tarjeta regalo se cobra una sola vez, al venderse. La parte de una compra pagada con tarjeta regalo aparece junto a lo cobrado, no dentro.",
    "ctx.moneyHelp.refunded": "Reembolsado: solo el dinero devuelto al cliente. El valor devuelto a una tarjeta regalo aparece en su propia línea.",
    "ctx.moneyHelp.owed": "Adeudado al profesional: su parte de la venta, impuestos incluidos (los declara él), se le haya pagado ya o no. Es Cobrado + tarjeta regalo − Comisión, salvo en la venta de una tarjeta regalo, cuyo valor queda reservado para su canje y aún no se adeuda a ningún profesional.",
    "ctx.moneyHelp.chargeback": "Contracargos: un contracargo solo reduce lo adeudado y la comisión cuando la pérdida se recupera del profesional.",
    "ctx.moneyHelp.source": "Las ventas del libro de pagos muestran sus importes, en su moneda de liquidación; las ventas anteriores y los pedidos pagados íntegramente con tarjeta regalo muestran su registro de pago.",
    "ctx.afterRefund": "Tras el reembolso",
    "ctx.charged": "Cargado {amount}",
    "ctx.checkoutAmount": "Importe solicitado {amount}",
    "ctx.notCollected": "No cobrado",
    "ctx.commissionKept": "retenida tras el reembolso",
    "ctx.owedAfterRefund": "adeudado tras el reembolso",
    "ctx.taxNotRecorded.refund": "El impuesto no se registra tras un reembolso",
    "ctx.taxNotRecorded.chargeback": "El impuesto no se registra tras un contracargo",
    "ctx.taxNotRecorded.refundAndChargeback": "El impuesto no se registra tras un reembolso y un contracargo",
    "ctx.giftcardHeld": "Reservado para el canje de la tarjeta regalo",
    "ctx.preLedgerRecord": "Venta anterior al libro: registro de pago",
    "ctx.preLedgerAdjusted": "Venta anterior al libro: no registrado tras un reembolso o disputa",
    "ctx.ledgerUnavailable": "No hay asiento en el libro para esta venta",
    "ctx.ledgerMixedCurrency": "Asientos del libro en más de una moneda: no se pueden sumar",
    "ctx.ledgerDisagrees.capture": "El libro registra un pago que esta venta no muestra",
    "ctx.ledgerDisagrees.refund": "El libro y esta venta no coinciden en el reembolso",
    "ctx.totalsLedgerCaptured.hidden": "{n} ventas figuran como no pagadas aunque el libro tiene su pago: no están en esta vista ni en estos totales. Elija «{unpaid}» para verlas.",
    "ctx.totalsLedgerCaptured.hiddenOne": "{n} venta figura como no pagada aunque el libro tiene su pago: no está en esta vista ni en estos totales. Elija «{unpaid}» para verla.",
    "ctx.totalsLedgerCaptured.listed": "{n} pagos no completados son pagos que el libro tiene: los registros de las ventas y el libro no coinciden, y no están en estos totales.",
    "ctx.totalsLedgerCaptured.listedOne": "{n} pago no completado es un pago que el libro tiene: el registro de la venta y el libro no coinciden, y no está en estos totales.",
    "ctx.totalsLabel.paid": "Importes cobrados, tras reembolsos y contracargos: todas las transacciones pagadas que coinciden con los filtros (todas las páginas)",
    "ctx.totalsLabel.all": "Importes cobrados, tras reembolsos y contracargos, de todas las transacciones que coinciden con los filtros (todas las páginas). Los pagos no completados se cuentan aparte y no suman nada.",
    "ctx.totalsLabel.unpaid": "Pagos no completados: no se cobró nada, así que no hay comisión ni pago al profesional.",
    "ctx.totalsLoading": "Calculando los totales…",
    "ctx.totalsTooLarge": "Demasiadas transacciones coinciden con estos filtros para totalizarlas a tiempo. Acote los filtros (una consulta, un tipo o un estado) para ver los totales.",
    "ctx.totalsFailed": "No se pudieron cargar los totales.",
    "ctx.totalNotCollected": "{n} pagos no completados ({amount}), fuera de estos totales",
    "ctx.totalNotCollectedOne": "{n} pago no completado ({amount}), fuera de estos totales",
    "ctx.totalOtherCurrency": "incl. {n} ventas cobradas en otra moneda",
    "ctx.totalOtherCurrencyOne": "incl. {n} venta cobrada en otra moneda",
    "ctx.giftcardApplied": "+ {amount} con tarjeta regalo",
    "ctx.giftcardCoveredRecord": "Pagado íntegramente con tarjeta regalo: registro de pago",
    "ctx.giftcardCoveredAdjusted": "Pagado con tarjeta regalo: no registrado tras un reembolso",
    "ctx.giftcardReturned": "{amount} devueltos a la tarjeta regalo",
    "ctx.totalGiftcardReturned": "{amount} devueltos a tarjetas regalo",
    "ctx.chargeback": "Contracargo",
    "ctx.afterChargeback": "Tras un contracargo",
    "ctx.owedAfterChargeback": "un contracargo lo reduce solo cuando se recupera del profesional",
    "ctx.totalChargeback": "Contracargos: −{amount}",
    "ctx.captureUnbooked": "Cobrado, aún no registrado en el libro",
    "ctx.totalNotCollectedNoAmount": "{n} pagos no completados, fuera de estos totales",
    "ctx.totalNotCollectedNoAmountOne": "{n} pago no completado, fuera de estos totales",
    "ctx.refHelp": "La referencia de pago identifica la venta en Stripe. Los reembolsos a clientes los emite la consulta desde su propia administración, con esta referencia.",
  },
};
